// @flow
import {
    borderRadius,
    controlPanelHeight,
    detailsPadding,
    iconsContainerHeight,
    marginDesktop,
    marginMobile,
    marginTablet,
    recipeItemAnimationDuration,
    textContainerHeight
} from '../style-variables';

import CSSTransition from 'react-transition-group/CSSTransition';
import Icon from '~/core/icons';
import { media } from '~/core/utils/style';
import styled from 'styled-components';
import TransitionGroup from 'react-transition-group/TransitionGroup';

const bezier = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const Margin = styled.div`
    margin: auto;
    max-width: 60em;
    padding: 0 1em;
`;

export const RecipesListContainer = styled(TransitionGroup)`
    display: flex;
    flex-wrap: wrap;
    left: ${-marginMobile}em;
    position: relative;
    width: calc(100% + ${2 * marginMobile}em);

    ${media.tablet`
		left: ${-marginTablet}em;
		width: calc(100% + ${2 * marginTablet}em);
	`} ${media.desktop`
		left: ${-marginDesktop}em;
		width: calc(100% + ${2 * marginDesktop}em);
	`};
`;

export const RecipeListItem = styled(CSSTransition)`
    &.animation-appear,
    &.animation-enter,
    &.animation-exit.animation-exit-active {
        transform: rotate3d(1, 0, 0, 90deg);
    }

    &.animation-appear.animation-appear-active,
    &.animation-enter.animation-enter-active,
    &.animation-exit {
        transform: rotate3d(1, 0, 0, 0);
    }

    &.animation-appear.animation-appear-active,
    &.animation-enter.animation-enter-active,
    &.animation-exit.animation-exit-active {
        transition: transform ${recipeItemAnimationDuration}ms ${bezier};
    }
`;

export const AddRecipeButton = styled.div`
    align-items: center;
    border: dashed 1px ${p => p.theme.mainBrandColor};
    border-radius: ${borderRadius}em;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: ${iconsContainerHeight + textContainerHeight + 2 * detailsPadding + controlPanelHeight}em;
    justify-content: center;
`;

export const AddIcon = styled(Icon)`font-size: 2em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipes-list/style.js